// src/store/thunks/templatesActions.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../utils/request";

// Fetch all templates
export const fetchTemplates = createAsyncThunk(
  "templates/fetchTemplates",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await request.get("/templates", { withCredentials: true });
      return data.templates;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Create a template
export const createTemplate = createAsyncThunk(
  "templates/createTemplate",
  async (template, { rejectWithValue }) => {
    try {
      const { data } = await request.post(
        "/templates",
        template,
        { withCredentials: true }
      );
      return data.template;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Update a template
export const updateTemplate = createAsyncThunk(
  "templates/updateTemplate",
  async (template, { rejectWithValue }) => {
    try {
      const { data } = await request.patch(
        `/templates/${template._id}`,
        template,
        { withCredentials: true }
      );
      return data.template;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Delete a template
export const deleteTemplate = createAsyncThunk(
  "templates/deleteTemplate",
  async (templateId, { rejectWithValue }) => {
    try {
      await request.delete(`/templates/${templateId}`, { withCredentials: true });
      return templateId;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
